import { render, staticRenderFns } from "./OwnershipPage.vue?vue&type=template&id=d645b00e&lang=pug"
import script from "./OwnershipPage.vue?vue&type=script&lang=js"
export * from "./OwnershipPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d645b00e')) {
      api.createRecord('d645b00e', component.options)
    } else {
      api.reload('d645b00e', component.options)
    }
    module.hot.accept("./OwnershipPage.vue?vue&type=template&id=d645b00e&lang=pug", function () {
      api.rerender('d645b00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_pendings/OwnershipPage.vue"
export default component.exports